import LoginForm from "../../forms/LoginForm";

const Login = () =>
{
  return <LoginForm/>
}

export default Login;
